import { FC } from 'react';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { RectangleDown } from './RectangleDown';
import { TTooltipProps } from './types';

export const Tooltip: FC<TTooltipProps> = ({ show, topPosition, color, amount, leftPosition }) => {
	return (
		<div
			style={{
				display: `${show ? 'block' : 'none'}`,
				position: 'absolute',
				top: `${String(topPosition)}px`,
				left: `calc(${String(leftPosition)}% + 40px)`, // '60px',
				zIndex: 4000,
			}}
		>
			<RectangleDown color={color} />
			{leftPosition > 50 && String(amount).length > 40 ? (
				<div
					style={{
						backgroundColor: `${String(color)}`,
						padding: '3px 8px',
						borderRadius: '5px',
						display: 'inline-block',
						color: 'white',
						fontWeight: 'bold',
						position: 'absolute',
						top: '-20px',
						whiteSpace: 'nowrap',
						boxShadow: '0 0 10px #00000080',
						fontSize: '14px',
						right: `calc(${String(leftPosition)}% - 80px)`,
						zIndex: 4000,
					}}
				>
					<AmountAndCurrency amount={amount} currency="EUR" size={1.1} type="symbol" />
				</div>
			) : (
				<div
					style={{
						backgroundColor: `${String(color)}`,
						padding: '3px 8px',
						borderRadius: '5px',
						display: 'inline-block',
						color: 'white',
						fontWeight: 'bold',
						position: 'absolute',
						top: '-20px',
						whiteSpace: 'nowrap',
						boxShadow: '0 0 10px #00000080',
						fontSize: '14px',
						// right: `calc(${String(leftPosition)}% - 40px)`,
						zIndex: 4000,
					}}
				>
					<AmountAndCurrency amount={amount} currency="EUR" size={1} type="symbol" />
				</div>
			)}
		</div>
	);
};
